jQuery(document).ready(function ($) {
  var $testimonialSliders = $(".testimonials-slider-inner .slider");

  function testimonialDotsAllTabbable($slider) {
    var el = $slider[0];
    if (!el) {
      return;
    }
    window.setTimeout(function () {
      $(el).find(".slick-dots button").attr("tabindex", "0");
    }, 0);
  }

  $testimonialSliders.on("init reInit afterChange", function () {
    testimonialDotsAllTabbable($(this));
  });

  $testimonialSliders.slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    prevArrow:
      '<button class="slick-prev" aria-label="Previous"><span class="fa fa-chevron-left"></span></button>',
    nextArrow:
      '<button class="slick-next" aria-label="Next"><span class="fa fa-chevron-right"></span></button>',
    dots: true,
    autoplay: false,
  });

  /**
   * Smash Balloon adds `.sbr_carousel` / Owl classes only after its own init.
   * Wait for the stage, then lock height to the tallest slide and vertically
   * center shorter reviews so the carousel doesn't jump between slides.
   */
  function getOwlInstance($carousel) {
    return $carousel.data("owl.carousel") || null;
  }

  function syncReviewsFeedStageHeight($carousel) {
    var owl = getOwlInstance($carousel);
    if (!owl) {
      return false;
    }

    // Smash Balloon can leave `items` as a padded string (e.g. "1 ").
    var items = parseInt(owl.settings.items, 10);
    if (!items || items < 1) {
      items = 1;
    }
    owl.settings.items = items;
    owl.options.items = items;

    // Keep a stable frame height — do not resize per slide.
    owl.settings.autoHeight = false;
    owl.options.autoHeight = false;

    var $stageOuter = $carousel
      .find(".sbr-owl-stage-outer, .owl-stage-outer")
      .first();
    var $owlItems = $carousel.find(".sbr-owl-item, .owl-item");
    if (!$stageOuter.length || !$owlItems.length) {
      return false;
    }

    // Clear prior sizing so we measure natural content height.
    $owlItems.each(function () {
      var wrap = this.querySelector(".sb-post-item-wrap");
      if (wrap) {
        wrap.style.minHeight = "";
        wrap.style.height = "";
      }
      this.style.height = "";
      this.style.minHeight = "";
    });
    $stageOuter.css("height", "").removeClass("sbr-owl-height");

    var maxHeight = 0;
    $owlItems.each(function () {
      // Skip empty / placeholder clones with no review body.
      if (!this.querySelector(".sb-item-text")) {
        return;
      }
      var height = Math.ceil($(this).outerHeight());
      if (height > maxHeight) {
        maxHeight = height;
      }
    });

    if (maxHeight <= 0) {
      return false;
    }

    $stageOuter.height(maxHeight);

    $owlItems.each(function () {
      var wrap = this.querySelector(".sb-post-item-wrap");
      if (!wrap) {
        return;
      }
      // Match the tallest frame so flex can vertically center short reviews.
      wrap.style.minHeight = maxHeight + "px";
    });

    return true;
  }

  function whenReviewsCarouselReady(root, callback) {
    var feed = root.querySelector(".sb-feed-posts");
    if (!feed) {
      return;
    }

    var done = false;
    var finish = function () {
      if (done) {
        return;
      }
      if (
        !feed.querySelector(".sbr-owl-stage-outer") &&
        !feed.classList.contains("sbr-owl-loaded")
      ) {
        return;
      }
      done = true;
      callback($(feed));
    };

    finish();
    if (done) {
      return;
    }

    if (typeof MutationObserver !== "undefined") {
      var observer = new MutationObserver(function () {
        finish();
        if (done) {
          observer.disconnect();
        }
      });
      observer.observe(feed, {
        attributes: true,
        attributeFilter: ["class"],
        childList: true,
        subtree: true,
      });
    }

    [200, 500, 1000, 2000, 4000].forEach(function (delay) {
      window.setTimeout(finish, delay);
    });
  }

  function initTestimonialsReviewsFeedHeight() {
    document
      .querySelectorAll(".testimonials-reviews-feed")
      .forEach(function (root) {
        whenReviewsCarouselReady(root, function ($carousel) {
          syncReviewsFeedStageHeight($carousel);

          // Recalc only when layout can change — not on every slide.
          $carousel.on(
            "initialized.owl.carousel refreshed.owl.carousel resized.owl.carousel",
            function () {
              window.setTimeout(function () {
                syncReviewsFeedStageHeight($carousel);
              }, 50);
            },
          );
        });
      });

    $(window).on(
      "load.testimonialsReviewsFeed resize.testimonialsReviewsFeed",
      function () {
        document
          .querySelectorAll(".testimonials-reviews-feed .sb-feed-posts")
          .forEach(function (feed) {
            syncReviewsFeedStageHeight($(feed));
          });
      },
    );
  }

  initTestimonialsReviewsFeedHeight();

  function updateLogosLayout(root, staticRow) {
    var reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)");
    if (reduceMotion.matches) {
      root.classList.remove("testimonials-slider-logos--marquee-mode");
      return;
    }
    root.classList.remove("testimonials-slider-logos--marquee-mode");
    var overflow = staticRow.scrollWidth > staticRow.clientWidth + 2;
    if (overflow) {
      root.classList.add("testimonials-slider-logos--marquee-mode");
    }
  }

  function initTestimonialsLogosOverflowMarquee() {
    document
      .querySelectorAll(".testimonials-slider-logos")
      .forEach(function (root) {
        var staticRow = root.querySelector(".testimonials-slider-logos-static");
        var inner = root.querySelector(".testimonials-slider-logos-inner");
        if (!staticRow || !inner) {
          return;
        }

        function update() {
          updateLogosLayout(root, staticRow);
        }

        update();

        if (typeof ResizeObserver !== "undefined") {
          var ro = new ResizeObserver(update);
          ro.observe(inner);
        }
        $(window).on("resize.testimonialsLogos", update);
      });

    (function () {
      var mq = window.matchMedia("(prefers-reduced-motion: reduce)");
      var onReduceChange = function () {
        document
          .querySelectorAll(".testimonials-slider-logos")
          .forEach(function (root) {
            var staticRow = root.querySelector(
              ".testimonials-slider-logos-static",
            );
            if (staticRow) {
              updateLogosLayout(root, staticRow);
            }
          });
      };
      if (mq.addEventListener) {
        mq.addEventListener("change", onReduceChange);
      } else if (mq.addListener) {
        mq.addListener(onReduceChange);
      }
    })();

    $(window).on("load", function () {
      document
        .querySelectorAll(".testimonials-slider-logos")
        .forEach(function (root) {
          var staticRow = root.querySelector(
            ".testimonials-slider-logos-static",
          );
          if (staticRow) {
            updateLogosLayout(root, staticRow);
          }
        });
    });
  }

  initTestimonialsLogosOverflowMarquee();
});
